<template>
  <vx-card class="mt-base" title="Law Activity 12 - Criminal Case Scenario - Part #3">
    <h4 class="mb-5">The Verdict and Sentencing</h4>

    <p class="mb-5">
      In this episode, the jury reaches their verdict. This video focuses on the sentencing process
      and the impact of offending on both the offender and the victim’s family.
    </p>
    <centered-image-wrapper
      :image="videos[1].image"
      classes="2/3"
      label="Play video: Criminal Trial, Episode 3"
      @clicked="showIframePopup(videos[1].video)"
    />
    <p class="mb-5">
      In this video, Chief Judge Kidd discussed the sentencing process. The Chief Judge explained
      that sentencing is not mathematical but that it involves applying a number of important
      principles.
    </p>
    <p class="mb-5">
      In the table below, each of these sentencing principles is listed in the column on the left.
      In the column on the right, in the space provided, explain what you think each of these
      sentencing principles means.
    </p>

    <table class="table default-table">
      <tr class="header">
        <th width="50%">SENTENCING PRINCIPLE</th>
        <th>MEANING</th>
      </tr>
      <tr class="body" v-for="(term, index) in terms" :key="index">
        <td>{{ term }}</td>
        <td><text-block v-model="data['question' + index]" :editable="isEditable" /></td>
      </tr>
    </table>
    <save-buttons :is-editable="isEditable" @save="save" />
  </vx-card>
</template>

<script>
import computed from '@/views/WorkExperiences/components/activity_js/computed';
import inject from '@/views/WorkExperiences/components/activity_js/inject';
import methods from '@/views/WorkExperiences/components/activity_js/methods';
export default {
  data() {
    return {
      videos: {
        1: {
          image: require('@/assets/images/experiences/law/criminal_case_part_3_splash.jpg'),
          video: 'https://www.youtube.com/embed/W6czPhGQ4Rw',
        },
      },
      terms: [
        'Punishment',
        'Specific Deterrence',
        'General Deterrence',
        'Rehabilitation',
        'Denunciation',
        'Protection of the Community',
      ],
    };
  },
  methods: methods,
  computed: computed,
  inject: inject,
};
</script>
